import leadApi from '@src/features/leads/services/lead-api';
import {
  EditablePhoneNumberCell,
  EditablePhoneNumberCellViewMode,
} from '@src/shared/components/editable-phone-number-cell';

import { EditablePhoneNumberCellEditMode } from '@src/shared/components/editable-phone-number-cell';
import type { TLead } from '@src/shared/types/lead';

export function LeadPhoneNumberCell({ lead }: { lead: TLead }) {
  const { mutate: updateLead, variables, error } = leadApi.useUpdate();

  const displayValue = error
    ? lead.phone_number
    : variables?.phone_number || lead.phone_number || '-';

  return (
    <EditablePhoneNumberCell copyToText={lead.phone_number}>
      <EditablePhoneNumberCellViewMode>
        {displayValue}
      </EditablePhoneNumberCellViewMode>

      <EditablePhoneNumberCellEditMode
        key={displayValue}
        value={displayValue}
        onBlur={(value) => {
          if (value.trim() === lead.phone_number?.trim()) return;
          updateLead({
            id: lead.id,
            phone_number: value,
          });
        }}
      />
    </EditablePhoneNumberCell>
  );
}
